export enum CapacityStatus {
  Free = 'free',
  Active = 'active',
  Busy = 'busy',
  Full = 'full',
  Overloaded = 'overloaded',
  Away = 'away'
}
